module.exports = __webpack_public_path__ + "img/nye-2023-btn.b8606cfb.png";